<template>
  <div ref="container">
    <a-modal :title="title" width="90%" :visible="visible" :maskStyle="{ 'top': '93px', 'left': '154px' }"
      @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:10%;height: 80%;">
      <a-table :dataSource="dataSource" :pagination="ipagination" :columns="columns" :loading="loading" @change="handleTableChange">
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import { accumulategetByNumberNew } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
export default {
  name: 'UDIOutlistDialog',
  mixins: [JeecgListMixin],
  data () {
    return {
      title: '出库统计详情',
      visible: false,
      model: {},

      dataSource: [],
      loading: false,
      url: {
        list: '/report/getByNumber',

      },
      columns: [
        {
          title: '产品码',
          dataIndex: 'code',
          width: 140,
        },
        {
          title: '入库仓库',
          dataIndex: 'depotName',
          width: 140,
        },
        {
          title: '防伪名称',
          dataIndex: 'piName',
          width: 140,
        },
        {
          title: '产品名称',
          dataIndex: 'materialName',
          width: 140,
        },
        {
          title: 'UDI名称',
          dataIndex: 'udiName',
          width: 140,
        },
        {
          title: '规格',
          dataIndex: 'standard',
          width: 140,
        },
        {
          title: '数量',
          dataIndex: 'quantity',
          width: 80,
        },

        {
          title: '包装详情',
          dataIndex: 'details',
          width: 120,
        },
      ],
    }
  },
  created () { },
  methods: {
    async add (e, type) {
      this.title = `${type}统计详情`
      this.columns[1].title = `${type}仓库`
      console.log(e, 'e122')
      this.visible = true

      this.topQueryParam.number = e
      this.loadData(1)
    },
    close () {
      this.$emit('close')
      this.visible = false
    },
    handleOk () {
      // 触发表单验证
      this.handleCancel()
    },
    handleCancel () {
      this.close()
    },

  },
}
</script>
<style scoped></style>